import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import {animateScroll as scroll} from "react-scroll";

export default function Home() {
    useEffect(() => {
        scroll.scrollToTop();
    }, []);

    return(
        <>
            <About />
            <Work />
            <Contact />
        </>
    )
}

export function About() {
    return(
        <>
            <div className={'h-1/4 text-white bg-black shadow-sm py-2 select-none'}>
                <div className={'ms:py-[50px] py-[20px]'}>
                    <div className={'md:text-[56px] text-[36px] font-[600] text-center'}>
                        <span>Hello</span>
                        <span>, I'm Hanoon</span>
                    </div>
                    <div className={'md:text-[36px] text-[24px] font-[400] text-center'}>
                        <span className={'text-[#6e6e73] px-2 italic'}>
                        a software engineering student
                    </span>
                    </div>
                </div>
            </div>
        </>
    )
}

export function Work() {
    return(
        <>
            <div className={'h-1/2 select-none bg-white md:my-10 my-5 py-2 shadow-sm flex flex-col items-center'}>
                <img src={require("./Assets/work.png")} alt={'Work'} className={'my-auto md:w-[800px] md:h-[450px] w-[400px] h-[200px] px-3'} />
                <div className={'md:block hidden text-[#6e6e73] hover:text-black absolute md:pt-[50px] md:text-[36px] text-[24px] font-[600] text-center'}>
                    <Link to={'/work'}>View my work</Link>
                </div>
                <div className={'md:hidden block border-2 border-[#6e6e73] rounded-full px-2 text-black mt-[25px] absolute md:pt-[50px] md:text-[36px] text-[18px] font-[600] text-center'}>
                    <Link to={'/work'}>View my work</Link>
                </div>
            </div>
        </>
    )
}

export function Contact() {
    return(
        <>
            <div className={'h-1/4 py-2'}>
                <div className={'md:text-[28px] text-[18px] font-[600] flex justify-center select-none'}>
                    <p className={'px-1 text-[#6e6e73]'}>You can reach out to me via </p>
                    <a className={'hover:font-[700] md:block hidden'} href = "mailto: ahmedhanoon02@gmail.com">
                        mail
                    </a>
                    <span className={'text-[#6e6e73] md:hidden block'}>
                        mail
                    </span>

                </div>
                <div className={'flex justify-center font-[400] items-center italic md:text-[18px] text-[12px] pb-5'}>
                    <p className={'select-none'}>(</p>
                    <p>ahmedhanoon02@gmail.com</p>
                    <p className={'select-none'}>)</p>
                </div>
                {/*<div className={'flex justify-center py-2 select-none'}>*/}
                {/*    <a href={'https://www.linkedin.com/in/ahmed-hanoon-464922221'} target={"_blank"}><img src={require("./Assets/linkdn.png")} alt={'linkdn'} className={'md:w-[45px] md:h-[35px] w-[35px] h-[25px] px-1'} /></a>*/}
                {/*    <a href={'https://github.com/Hanoon02'} target={"_blank"}><img src={require("./Assets/github.png")} alt={'linkdn'} className={'md:w-[45px] md:h-[35px] w-[35px] h-[25px] px-1'} /></a>*/}
                {/*</div>*/}
            </div>
        </>
    )
}

